var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14078 15.2014L8.05918 12.4026C8.62245 12.0002 9.37912 12.0002 9.94239 12.4026L13.8608 15.2014L13.8608 1.43963L4.14078 1.43963L4.14078 15.2014ZM13.8777 16.9831C14.4733 17.4086 15.3008 16.9828 15.3008 16.2508L15.3008 0.89963C15.3008 0.402575 14.8978 -0.00036999 14.4008 -0.000369947L3.60078 -0.000369003C3.10372 -0.000368959 2.70078 0.402576 2.70078 0.899631L2.70078 16.2508C2.70078 16.9828 3.52821 17.4086 4.1239 16.9831L8.89616 13.5744C8.95874 13.5297 9.04282 13.5297 9.1054 13.5744L13.8777 16.9831Z",
    fill: "#F5F5F5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.c552ece753fbefb87f6c202a42a272d8.svg";
export { ForwardRef as ReactComponent };